import React, { PureComponent } from 'react';
import TabbedComponents from '../components/TabbedComponents';
import MetricsRow from '../components/MetricsPage/MetricsRow';
import MetricsHeader from '../components/MetricsPage/MetricsHeader';
import { BASE_URL } from '../config';
require('!style!css!less!../css/table.less'); // eslint-disable-line

export default class MetricsPage extends PureComponent {
  state = {
    components: [],
  };

  componentDidMount() {
    fetch(`${BASE_URL}/spa_data/metrics_page.json`)
      .then(result => result.json())
      .then((json) => {
        this.setState({
          components: json,
        });
      });
  }

  render() {
    return (
      <div>
        <h2 style={{margin: '28px 10px 26px 10px'}}>Metrics</h2>
        <TabbedComponents
          components={this.state.components}
          header={MetricsHeader}
          row={MetricsRow}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MetricsPage.jsx